<template>
  <div class="segment container">
    <div class="title is-4 has-text-centered">{{ $t("change password") }}</div>
    <div class="field">
      <label class="label" for="current_password">{{
        $t("current password")
      }}</label>
      <div class="control">
        <input
          class="input"
          type="password"
          id="current_password"
          v-model="meta.current_password"
          required
        />
      </div>
    </div>
    <div class="field">
      <label class="label" for="new_password">{{ $t("new password") }}</label>
      <div class="control">
        <input
          class="input"
          type="password"
          id="new_password"
          v-model="meta.new_password"
          required
        />
      </div>
    </div>
    <div class="field">
      <label class="label" for="confirm_password">{{
        $t("confirm password")
      }}</label>
      <div class="control">
        <input
          class="input"
          type="password"
          id="confirm_password"
          v-model="meta.confirm_password"
          required
        />
      </div>
    </div>
    <div class="field">
      <div class="control is-fluid">
        <button
          class="button is-primary"
          @click="update_password"
          :disabled="
            !meta.new_password ||
            !meta.confirm_password ||
            meta.new_password != meta.confirm_password ||
            pass_requirements(meta.new_password) === false
          "
        >
          {{ $t("change password") }}
        </button>
      </div>
    </div>

    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>

    <div class="notification is-info mt-5 is-dark">
      <div class="title is-6 mb-3">
        {{ $t("password requirements") }}
      </div>
      <ul>
        <li
          v-if="
            user_data &&
            user_data.enterprise_settings &&
            user_data.enterprise_settings.password_min_length
          "
        >
          {{ $t("minimum characters length") }}:
          {{ user_data.enterprise_settings.password_min_length }}
        </li>
        <li
          v-if="
            user_data &&
            user_data.enterprise_settings &&
            user_data.enterprise_settings.password_must_have_number
          "
        >
          {{ $t("at least 1 number") }}
        </li>
        <li
          v-if="
            user_data &&
            user_data.enterprise_settings &&
            user_data.enterprise_settings.password_must_have_uppercase
          "
        >
          {{ $t("at least 1 uppercase letter") }}
        </li>
        <li
          v-if="
            user_data &&
            user_data.enterprise_settings &&
            user_data.enterprise_settings.password_must_have_special_character
          "
        >
          {{ $t("at least 1 special character") }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { generate_error_message_text, put, get_user_data } from "@/utils";
import jssha1 from "js-sha1";

export default {
  name: "ChangePasswordView",
  data() {
    return {
      meta: {
        new_password: "",
        confirm_password: "",
      },
      error: "",
    };
  },
  computed: {
    user_data() {
      return get_user_data();
    },
  },
  methods: {
    pass_requirements(password) {
      let enterprise_settings = this.user_data?.enterprise_settings;
      if (!enterprise_settings) return true;

      if (
        enterprise_settings.password_min_length &&
        password.length < enterprise_settings.password_min_length
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_number &&
        !/\d/.test(password)
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_uppercase &&
        !/[A-Z]/.test(password)
      ) {
        return false;
      }
      if (
        enterprise_settings.password_must_have_special_character &&
        !/[!@#$%^&*(),.?":{}|<>]/.test(password)
      ) {
        return false;
      }
      return true;
    },
    update_password() {
      let v = this;
      // console.log("update_password");
      put("/system/authentication/change-password", {
        current_password: jssha1(v.meta.current_password),
        new_password: jssha1(v.meta.new_password),
      })
        .then(() => {
          v.$router.replace({
            path: "/home",
          });
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
};
</script>

<style scoped></style>

<!-- No custom styles, Bulma is used -->
